/**
 * @generated SignedSource<<384aaae218044d86be96222921d5c6e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileBaseInlineFragment$data = {
  readonly id: string;
  readonly email: string;
  readonly externalRef: string;
  readonly countryId: string | null;
  readonly timeZone: string;
  readonly photoUrls: any | null;
  readonly " $fragmentType": "userProfileBaseInlineFragment";
};
export type userProfileBaseInlineFragment$key = {
  readonly " $data"?: userProfileBaseInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileBaseInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "userProfileBaseInlineFragment"
};

(node as any).hash = "fa586dd222b9c47bf586a19dd028f262";

export default node;
